import {Type} from '../../../shared/Type';
import {Level} from '../../../shared/Level';
import {Article} from '../../../shared/Article';
import {Country} from '../../../shared/Country';

export class VocabEntryCreationDto {
  constructor(
    public id: number,
    public name: string,
    public vocabType: Type,
    public receptive: Level,
    public productive: Level,
    public article: Article,
    public categoryId: number,
    public plural: string,
    public present: string,
    public simplePast: string,
    public pastParticiple: string,
    public country: Country,
    public comment: string,
    public examples: string[],
    public test: string,
    public isSingular: boolean,
    public vocabCategoryIds: number[],
    public vocabEntryIds: number[],
    public functionalGrammarCategoryIds: number[],
    public functionalGrammarEntryIds: number[],
    public systemicGrammarCategoryIds: number[],
    public systemicGrammarEntryIds: number[],
    public textPatternIds: number[],
    public textTypeIds: number[],
    public detailedCanDoStatementCategoryIds: number[],
    public detailedCanDoStatementEntryIds: number[],
    public globalCanDoStatementCategoryIds: number[],
    public globalCanDoStatementEntryIds: number[]
  ) {
  }
}
